
import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import Icon from '@/components/UI/Icon.vue';
import Tooltip from '@/components/UI/Tooltip.vue';
import DateTimezoneToggle from '@/components/UI/dateTimezoneToggle/DateTimezoneToggle.vue';
import { checkTicketIsRfc } from '@/utils/Common';
import { JobTicketListItem } from '@/models/jobTicket';

@Component({
  components: {
    DateTimezoneToggle,
    Icon,
    Tooltip,
  },
  computed: {
    ...mapState('moduleUser', { user: 'user' }),
  },
})
export default class ZammadList extends Vue {
  @Prop({ type: Array, required: false, default: 'base' }) public ticketsData: JobTicketListItem[];

  public checkTicketIsRfc = checkTicketIsRfc;

  public articleClicked(ticket) {
    this.$emit('zammadArticleClicked', ticket);
  }
}
